import { Component, inject } from '@angular/core';
import { BaseClientTaskHistoryComponent } from '../base-client-task-history/base-client-task-history.component';
import { ClientPrescriberTasksService } from 'app/core/services/client-prescriber-tasks.service';

import { ClientTaskNavComponent } from '../../components/client-task-nav/client-task-nav.component';
import { ClientTaskHistoryItemListComponent } from '../../components/client-task-history-item-list/client-task-history-item-list.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-client-prescriber-task-history',
  templateUrl: './client-prescriber-task-history.component.html',
  styleUrls: ['./client-prescriber-task-history.component.scss'],
  imports: [ClientTaskNavComponent, ClientTaskHistoryItemListComponent, MatProgressSpinner]
})
export class ClientPrescriberTaskHistoryComponent extends BaseClientTaskHistoryComponent {
  constructor() {
    const clientTasksService = inject(ClientPrescriberTasksService);

    super(clientTasksService);
  }
}
